// extracted by mini-css-extract-plugin
export default {"wrapper":"TagItem_wrapper__+B1KG","close":"TagItem_close__RwWAi","disabled":"TagItem_disabled__q9Tpn"};